export enum FormType {
  Standalone = 'Standalone',
  Synchronized = 'Synchronized'
}
